(function () {

  var trainingGroupMedia = document.querySelectorAll('.training-group-media');
  var styles_count = 6
  var decoId = parseInt(trainingGroupMedia[0].getAttribute('data-decoration-id')) ?? 0;

  trainingGroupMedia.forEach(function (el, i) {
    if (el.hasAttribute('data-decoration-theme')) {
      var themes = {
        'mauve_grey': 0,
        'turquoise_black': 5,
        'turquoise_light_grey': 3,
        'grey_orange': 1,
        'grey_black': 4,
        'yellow_black': 2,
      }
      var theme = el.getAttribute('data-decoration-theme')
      el.classList.add('training-group-media-' + themes[theme])
    } else {
      el.classList.add('training-group-media-' + ((i + decoId) % styles_count));
    }
  });

})()
